function buildTopBar() {
  const top_bar = {
    label: 'Editing :',
    formName: '',
    formId: '',
  };
  return top_bar;
}

function buildHero() {
  const hero = {
    title: 'Form Structure',
    description: 'Organize your form into logical sections.',
  };
  return hero;
}

function buildActions() {
  const actions = {
    add_section_label: 'Add Main Section',
    add_sub_section_label: 'Add Sub Section',
    add_question_label: 'Add Question',
    assign_existing_question_label: 'Assign Existing Question',
    edit_question_label: 'Edit Question',
    add_form_instructions_label: 'Add Form Instructions',
  };
  return actions;
}

function buildFormInstruction() {
  return {
    content: '',
    type: 'paragraph',
  };
}

function buildSidebar() {
  const sidebar = {
    preview_title: 'Preview Live Form',
    preview_description: 'See how it looks for suppliers',
  };
  return sidebar;
}

function buildNewMainSection() {
  const section = {
    main_section_name: '',
    order_number: 0,
    existing_main_section_id: '',
  };
  return section;
}

function buildNewSubSection() {
  const section = {
    section_name: '',
    order_number: 0,
    existing_section_id: '',
    form_instructions: [{ content: '', type: 'paragraph' }],
  };
  return section;
}

function buildCurrentEditSection() {
  const section = {
    section_id: null,
    name: '',
    form_instructions: [{ content: '', type: 'paragraph' }],
    is_deleting: false,
  };
  return section;
}

function buildCurrentEditMainSection() {
  const main_section = {
    main_section_id: null,
    main_section_name: '',
    main_section_description: '',
    is_deleting: false,
  };
  return main_section;
}

function buildCurrentEditQuestion() {
  const question = {
    question_id: null,
    question_text: '',
    question_description: '',
    question_type_id: '',
    is_mandatory: true,
    is_unique: false,
    question_number: '',
    show_option_inputs: false,
    option_inputs: ['', ''],
    multi_select_options: [],
    dependant_questions: [],
  };
  return question;
}

function buildStatusFlags() {
  return {
    creating_main_section: false,
    editing_main_section: false,
    deleting_main_section: false,
    deleting_sub_section: false,
    reordering_main_sections: false,
    reordering_sub_sections: false,
    reordering_section_questions: false,
    creating_question: false,
    editing_question: false,
  };
}

function buildDragState() {
  return {
    dragged_main_section: null,
    dragged_sub_section: null,
    dragged_question: null,
  };
}

function buildModalState() {
  return {
    main_section_modal_open: false,
    subsection_modal_open: false,
    question_modal_open: false,
    assign_existing_question_modal_open: false,
    edit_question_modal_open: false,
    form_instruction_modal_open: false,
  };
}

function buildErrorState() {
  return {
    order_number_error: false,
    main_section_name_error: false,
    sub_section_name_error: false,
    edit_main_section_name_error: false,
    edit_section_name_error: false,
    question_text_error: false,
    edit_question_error: false,
  };
}

function buildActiveSelectionState() {
  return {
    active_question_section: null,
    active_assign_section: null,
    active_question_section_index: null,
    active_question_index: null,
    active_edit_section_index: null,
    current_edit_section_index: null,
    active_main_section_name: '',
    active_main_section_id: null,
  };
}

function buildCollectionsState() {
  return {
    main_sections: [],
    sections: [],
    reusable_main_sections: [],
    reusable_sub_sections: [],
    question_forms: [],
    question_list: [],
    verification_services: [],
    verification_required_fields_by_service: {},
  };
}

function buildPaginationState() {
  return {
    current_page: 1,
    page_size: 5,
  };
}

function buildVerificationState() {
  return {
    verification_guidance_loading: false,
    verification_form_id: '',
    verification_active_service_id: '',
  };
}

function buildFormInstructionTypes() {
  return [
    { value: 'paragraph', label: 'Paragraph', icon: 'bi-paragraph' },
    { value: 'short_text', label: 'Short text', icon: 'bi-input-cursor-text' },
    { value: 'list', label: 'List', icon: 'bi-list-ul' },
  ];
}

function buildCreateSectionsState() {
  const data = {
    ...buildStatusFlags(),
    ...buildDragState(),
    ...buildModalState(),
    ...buildErrorState(),
    ...buildActiveSelectionState(),
    ...buildCollectionsState(),
    ...buildPaginationState(),
    ...buildVerificationState(),
    section_id_counter: 0,
    question_id_counter: 0,
    topBar: buildTopBar(),
    hero: buildHero(),
    new_main_section: buildNewMainSection(),
    new_sub_section: buildNewSubSection(),
    main_section_mode: 'new',
    sub_section_mode: 'new',
    current_edit_section: buildCurrentEditSection(),
    current_edit_main_section: buildCurrentEditMainSection(),
    current_edit_question: buildCurrentEditQuestion(),
    is_loading_questions: false,
    question_search: '',
    actions: buildActions(),
    sidebar: buildSidebar(),
    form_instructions: [],
    editing_form_instruction_index: null,
    current_form_instruction: buildFormInstruction(),
    form_instruction_types: buildFormInstructionTypes(),
  };
  return data;
}

export function create_sections_data() {
  return buildCreateSectionsState();
}
